<template>
  <div v-if="isRouterAlive">
    <Slider
      :banner="$t('sliderimg')"
    >
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-joinus-title fontsiyuanmedium">{{$t('slidertitle')}}</div>
          <div class="slider-joinus-subtitle fontsiyuanregular">{{$t('slidersubtitle')}}</div>
        </div>
      </div>
    </Slider>
    <div>
      <div class="joinus-list">
        <b-container>
          <b-row class="justify-content-md-center download-head">
            <b-col cols="8" sm="12" lg="8">
              <div class="head-title">{{$t('toptitle')}}</div>
              <div class="head-subtitle">
                {{$t('topdesc')}}
              </div></b-col
            >
          </b-row>
          <b-row>
            <b-col cols="8" sm="12" lg="8">
              <b-table-simple hover small caption-top responsive>
                <b-thead>
                  <b-tr class="joinus-grid-head">
                    <b-th
                      >{{ $t('gridtitlet1') }}</b-th
                    >
                    <b-th
                      >{{ $t('gridtitlet2') }}</b-th
                    >
                    <b-th
                      >{{ $t('gridtitlet3') }}</b-th
                    >
                    <b-th
                      >{{ $t('gridtitlet4') }}</b-th
                    >
                    <b-th
                      >{{ $t('gridtitlet5') }}</b-th
                    >
                    <b-th
                      ></b-th
                    >
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr
                    class="joinus-grid-row"
                    v-for="(item, index) in JSON.parse($t('joinusgridlist'))"
                    v-bind:key="index"
                  >
                    <b-td
                      style="
                        white-space: nowrap;
                        padding-right: 20px;
                        font-weight: bold;
                        padding-top: 20px;
                        padding-bottom: 20px;
                        vertical-align: middle;
                      "
                    >
                      {{ item[0] }}
                    </b-td>
                    <b-td
                      style="
                        font-size: 12px;
                        color: #888;
                        padding-right: 20px;
                        vertical-align: middle;
                      "
                    >
                      {{ item[1] }}
                    </b-td>
                    <b-td
                      style="
                        white-space: nowrap;
                        font-size: 12px;
                        color: #888;
                        padding-right: 20px;
                        vertical-align: middle;
                      "
                    >
                      {{ item[2] }}
                    </b-td>
                    <b-td
                      style="
                        white-space: nowrap;
                        font-size: 12px;
                        color: #888;
                        padding-right: 20px;
                        vertical-align: middle;
                      "
                    >
                      {{ item[3] }}
                    </b-td>
                    <b-td
                      style="
                        white-space: nowrap;
                        font-size: 12px;
                        color: #888;
                        padding-right: 20px;
                        vertical-align: middle;
                      "
                    >
                      {{ item[4] }}
                    </b-td>
                    <b-td style="vertical-align: middle">
                      <span class="contact-join">{{ $t('gridcontact') }}</span>
                    </b-td>
                  </b-tr></b-tbody
                >
              </b-table-simple></b-col
            >
          </b-row>
        </b-container>
      </div>
    </div>
    <div></div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      isRouterAlive: true,

    };
  },
  methods: {
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    },
    getJoinus() {
      const _this = this;
      this.$store.dispatch("getJoinus").then(({zh,en}) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

      let lang = _this.$i18n.locale
      _this.$i18n.locale = lang
      _this.reload()
      });
    },
  },
  mounted() {
    this.getJoinus();
  },
};
</script>
<style>
.slider-joinus-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-joinus-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.joinus-title-group {
  border-bottom: 0.5px #bdbdbd88 solid;
}
.joinus-title {
  padding: 20px 0;
}
.joinus-title.active {
  color: #c00f31;
  font-weight: bold;
}
.joinus-list {
  padding-bottom: 100px;
}
.joinus-list .col-sm-12{
 padding:0 auto;
 margin: 0 auto;
}
.joinus-list .col-lg-8{
 padding:0 auto;
 margin: 0 auto;
}
.joinus-list .col-8{
 padding:0 auto;
 margin: 0 auto;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.joinus-pagination {
  margin-top: 100px;
}
.joinus-item {
  margin-top: 50px;
  cursor: pointer;
}

.joinus-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.joinus-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.joinus-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.joinus-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.download-head {
  margin-top: 50px;
  margin-bottom: 50px;
}
.download-item {
  margin-bottom: 50px;
}
.download-item img {
  padding: 0 10px;
}
.download-info {
  font-size: 13px;
}
.head-title {
  font-size: 30px;
  font-weight: bold;
}
.head-subtitle {
  text-align: left;
  font-size: 15px;
  font-weight: 200;
}
.product-load-more {
  margin-top: 50px;
  font-weight: 300;
  color: #c0c4c8;
  border: 1px #c0c4c8 solid;
  border-radius: 0;
  padding-left: 50px;
  padding-right: 50px;
}
.product-load-more:hover {
  box-shadow: #00000034 0px 0px 0px;
}
.product-load-more:after {
  box-shadow: #00000034 0px 0px 0px;
}
.download-button {
  position: absolute;
  bottom: 0;
  margin-top: 50px;
  font-weight: 300;
  color: #000;
  border: 1px #000 solid;
  border-radius: 0;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 12px;
}
.download-button:hover {
  box-shadow: #000 0px 0px 0px;
}
.download-button:after {
  box-shadow: #000 0px 0px 0px;
}
.download-icon {
  width: 12px;
  height: 12px;
  /* https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/未标题-1-01.svg */
  background: url(https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/未标题-1-01.svg)
    no-repeat top center scroll;
  background-size: fit;
}

.joinus-grid-head {
  background-color: #ededed;
}

.joinus-grid-head th {
  white-space: nowrap;
}
.contact-join {
  white-space: nowrap;
  background-color: #c00f31;
  color: #fff;
  font-size: 12px;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
